// import React, { useState, useRef } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, Typography, Box, Divider, CircularProgress,
//   Alert, Chip, IconButton, Table, TableHead, TableBody,
//   TableRow, TableCell, Tabs, Tab, Collapse,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ErrorIcon from "@mui/icons-material/Error";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import TableChartIcon from "@mui/icons-material/TableChart";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
// import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import { ALLOWED_DOMAINS_DISPLAY, isSameUrl, isValidRedirectUrl } from "./redirectConfig";

// // ── Supported formats (no API needed) ────────────────────────────────────────
// const SUPPORTED = {
//   "text/csv": { label: "CSV", icon: "table", parser: "csv" },
//   "application/pdf": { label: "PDF", icon: "pdf", parser: "pdf" },
// };

// const ACCEPT = ".csv,.pdf";
// const FORMAT_BADGES = ["CSV", "PDF"];

// function getFileMeta(f) {
//   if (SUPPORTED[f.type]) return SUPPORTED[f.type];
//   const ext = f.name.split(".").pop().toLowerCase();
//   return {
//     csv: SUPPORTED["text/csv"], tsv: SUPPORTED["text/tab-separated-values"],
//     txt: SUPPORTED["text/plain"], pdf: SUPPORTED["application/pdf"]
//   }[ext] || null;
// }

// function FileTypeIcon({ icon }) {
//   if (icon === "pdf") return <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />;
//   if (icon === "table") return <TableChartIcon sx={{ color: "#2e7d32" }} />;
//   return <InsertDriveFileIcon sx={{ color: "#1976d2" }} />;
// }

// // ── Validation ────────────────────────────────────────────────────────────────
// function isValidUrl(v) {
//   return v && (v.startsWith("/") || v.startsWith("http://") || v.startsWith("https://"));
// }

// function buildParsed(rawRows) {
//   const valid = [], invalid = [];
//   rawRows.forEach(({ from, to, sc, active }, i) => {
//     if (!from || !to) {
//       invalid.push({ line: i + 1, raw: `${from} → ${to}`, reason: "Missing from or to URL" });
//     } else if (!isValidRedirectUrl(from)) {
//       invalid.push({ line: i + 1, raw: from, reason: `Invalid domain. Allowed: ${ALLOWED_DOMAINS_DISPLAY}` });
//     } else if (!isValidRedirectUrl(to)) {
//       invalid.push({ line: i + 1, raw: to, reason: `Invalid domain. Allowed: ${ALLOWED_DOMAINS_DISPLAY}` });
//     } else if (isSameUrl(from, to)) {
//       // ✅ Same URL check
//       invalid.push({ line: i + 1, raw: `${from} → ${to}`, reason: '"From" and "To" URLs cannot be the same' });
//     } else {
//       valid.push({
//         from_path: from.trim(),
//         to_url: to.trim(),
//         status_code: sc ? (Number(sc) || null) : null,
//         is_active: active !== undefined ? String(active).toLowerCase() !== "false" : true,
//       });
//     }
//   });
//   return { valid, invalid };
// }

// // ── CSV / TSV / TXT parser ────────────────────────────────────────────────────
// function parseDelimited(text, filename = "") {
//   const isTSV = filename.endsWith(".tsv");
//   const lines = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
//     .split("\n").map(l => l.trim()).filter(Boolean);
//   if (!lines.length) return buildParsed([]);

//   // Detect header row
//   const first = lines[0].toLowerCase();
//   const hasHeader = ["from", "original", "source", "old", "url", "path"]
//     .some(k => first.includes(k));
//   const dataLines = hasHeader ? lines.slice(1) : lines;

//   const rows = dataLines.map(line => {
//     // Detect separator: tab > comma > space
//     const sep = isTSV || line.includes("\t") ? "\t"
//       : line.includes(",") ? ","
//         : " ";
//     const cols = line.split(sep).map(c => c.trim().replace(/^["']|["']$/g, ""));
//     return { from: cols[0], to: cols[1], sc: cols[2], active: cols[3] };
//   });
//   return buildParsed(rows);
// }

// // ── PDF text extractor (pdf.js via CDN — no install needed) ──────────────────
// async function extractTextFromPDF(arrayBuffer) {
//   // Dynamically load pdf.js from CDN
//   if (!window.pdfjsLib) {
//     await new Promise((resolve, reject) => {
//       const script = document.createElement("script");
//       script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
//       script.onload = resolve;
//       script.onerror = reject;
//       document.head.appendChild(script);
//     });
//     window.pdfjsLib.GlobalWorkerOptions.workerSrc =
//       "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
//   }

//   const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
//   let fullText = "";
//   for (let p = 1; p <= pdf.numPages; p++) {
//     const page = await pdf.getPage(p);
//     const content = await page.getTextContent();
//     // Group items by their Y position to reconstruct rows
//     const byY = {};
//     content.items.forEach(item => {
//       const y = Math.round(item.transform[5]);
//       if (!byY[y]) byY[y] = [];
//       byY[y].push(item.str.trim());
//     });
//     const sortedYs = Object.keys(byY).map(Number).sort((a, b) => b - a);
//     sortedYs.forEach(y => {
//       const row = byY[y].filter(Boolean);
//       if (row.length >= 2) fullText += row.join("\t") + "\n";
//     });
//   }
//   return fullText;
// }

// // ── How-to guide content ──────────────────────────────────────────────────────
// const SAVE_GUIDES = [
//   {
//     label: "Google Sheets",
//     color: "#1a73e8",
//     steps: [
//       "Open your sheet with redirect URLs",
//       'Click File → Download → "Comma Separated Values (.csv)"',
//       "Upload that CSV file here",
//     ],
//     tip: 'Make sure column A = "From URL" and column B = "To URL"',
//   },
//   {
//     label: "Excel",
//     color: "#217346",
//     steps: [
//       "Open your Excel file",
//       'Click File → Save As → choose "CSV UTF-8 (Comma delimited) (.csv)"',
//       "Upload that CSV file here",
//     ],
//     tip: "Excel may warn about losing formatting — that's fine, click Keep.",
//   },
//   {
//     label: "Notion / Confluence",
//     color: "#000",
//     steps: [
//       "Select your redirect table",
//       "Copy all cells (Ctrl+A then Ctrl+C)",
//       'Use "Paste bulk" instead — paste directly into the text box',
//     ],
//     tip: "Notion tables paste as tab-separated, which works perfectly with Paste bulk.",
//   },
//   {
//     label: "PDF / Word Doc",
//     color: "#d32f2f",
//     steps: [
//       "Open the document and find the redirect table",
//       "Select all rows and copy",
//       'Use "Paste bulk" — paste the copied text there',
//       "Or: save as .txt and upload here",
//     ],
//     tip: "PDFs with selectable text also work — just upload the .pdf file directly.",
//   },
// ];

// // ── Main component ────────────────────────────────────────────────────────────
// export default function UploadFileModal({ open, onClose, onSave, loading }) {
//   const inputRef = useRef();
//   const [file, setFile] = useState(null);
//   const [fileMeta, setFileMeta] = useState(null);
//   const [parsed, setParsed] = useState(null);
//   const [dragOver, setDragOver] = useState(false);
//   const [fileError, setFileError] = useState("");
//   const [processing, setProcessing] = useState(false);
//   const [guideTab, setGuideTab] = useState(0);
//   const [guideOpen, setGuideOpen] = useState(false);

//   const reset = () => {
//     setFile(null); setFileMeta(null); setParsed(null);
//     setFileError(""); setProcessing(false);
//   };
//   const handleClose = () => { reset(); onClose(); };

//   const processFile = async (f) => {
//     if (!f) return;
//     const meta = getFileMeta(f);
//     if (!meta) {
//       setFileError(`Unsupported format. Accepted: ${FORMAT_BADGES.join(", ")}`);
//       return;
//     }
//     setFile(f); setFileMeta(meta); setFileError(""); setProcessing(true);

//     try {
//       if (meta.parser === "csv") {
//         const text = await f.text();
//         setParsed(parseDelimited(text, f.name));
//       } else if (meta.parser === "pdf") {
//         const buffer = await f.arrayBuffer();
//         const text = await extractTextFromPDF(buffer);
//         if (!text.trim()) {
//           throw new Error("No text could be extracted. This PDF may be scanned/image-based. Try saving as CSV instead.");
//         }
//         setParsed(parseDelimited(text, "extracted.tsv"));
//       }
//     } catch (err) {
//       setFileError(err.message || "Failed to parse file. Please check the format.");
//       setFile(null); setFileMeta(null);
//     } finally {
//       setProcessing(false);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault(); setDragOver(false);
//     processFile(e.dataTransfer.files[0]);
//   };

//   const handleConfirm = async () => {
//     if (!file) return;
//     await onSave(file);  // ← pass raw file object instead of parsed rows
//     reset();

//   };

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { borderRadius: 2 } }}>
//       <DialogTitle sx={{
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//         pb: 1, fontWeight: 600, fontSize: "1rem"
//       }}>
//         Upload redirects file
//         <IconButton size="small" onClick={handleClose}><CloseIcon fontSize="small" /></IconButton>
//       </DialogTitle>
//       <Divider />

//       <DialogContent sx={{ pt: 2 }}>
//         {!parsed && !processing ? (
//           <>
//             {/* ── Drop zone ── */}
//             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mb: 1.5 }}>
//               {FORMAT_BADGES.map(f => (
//                 <Chip key={f} label={f} size="small" variant="outlined"
//                   sx={{ fontSize: 11, height: 22, borderColor: "#e0e0e0", color: "#616161" }} />
//               ))}
//             </Box>

//             <Box
//               onClick={() => inputRef.current?.click()}
//               onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
//               onDragLeave={() => setDragOver(false)}
//               onDrop={handleDrop}
//               sx={{
//                 border: `2px dashed ${dragOver ? "#1976d2" : fileError ? "#d32f2f" : "#bdbdbd"}`,
//                 borderRadius: 2, p: 5, textAlign: "center", cursor: "pointer",
//                 backgroundColor: dragOver ? "#f0f7ff" : "#fafafa",
//                 transition: "all 0.2s",
//                 "&:hover": { borderColor: "#1976d2", backgroundColor: "#f0f7ff" },
//               }}>
//               <UploadFileIcon sx={{ fontSize: 44, color: dragOver ? "#1976d2" : "#bdbdbd", mb: 1 }} />
//               <Typography fontWeight={500} mb={0.5}>Drag & drop your file here</Typography>
//               <Typography fontSize={13} color="text.secondary">or click to browse</Typography>
//               <Typography fontSize={12} color="text.secondary" mt={1}>
//                 CSV · TSV · TXT · PDF — no API needed, all processed locally
//               </Typography>
//               {fileError && (
//                 <Typography fontSize={13} color="error" mt={1.5}
//                   sx={{ maxWidth: 480, mx: "auto" }}>{fileError}</Typography>
//               )}
//             </Box>
//             <input ref={inputRef} type="file" accept={ACCEPT} hidden
//               onChange={(e) => processFile(e.target.files[0])} />

//             {/* ── How to save guide ── */}
//             <Box sx={{ mt: 2, border: "1px solid #e3f2fd", borderRadius: 2, overflow: "hidden" }}>
//               <Box
//                 onClick={() => setGuideOpen(g => !g)}
//                 sx={{
//                   display: "flex", alignItems: "center", gap: 1, px: 2, py: 1.2,
//                   cursor: "pointer", backgroundColor: "#f0f7ff",
//                   "&:hover": { backgroundColor: "#e3f2fd" }
//                 }}>
//                 <LightbulbOutlinedIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                 <Typography fontSize={13} fontWeight={600} color="#1565c0" sx={{ flex: 1 }}>
//                   How to export your redirect list as a file
//                 </Typography>
//                 {guideOpen
//                   ? <ExpandLessIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                   : <ExpandMoreIcon sx={{ fontSize: 18, color: "#1976d2" }} />}
//               </Box>

//               <Collapse in={guideOpen}>
//                 <Box sx={{ px: 2, pt: 1.5, pb: 2 }}>
//                   <Tabs value={guideTab} onChange={(_, v) => setGuideTab(v)}
//                     sx={{
//                       mb: 1.5, minHeight: 32,
//                       "& .MuiTab-root": { textTransform: "none", fontSize: 12, minHeight: 32, py: 0.5 },
//                       "& .Mui-selected": { color: "#1976d2 !important" },
//                       "& .MuiTabs-indicator": { backgroundColor: "#1976d2" },
//                     }}>
//                     {SAVE_GUIDES.map((g, i) => (
//                       <Tab key={i} label={g.label} />
//                     ))}
//                   </Tabs>

//                   {SAVE_GUIDES.map((guide, i) => (
//                     guideTab === i && (
//                       <Box key={i}>
//                         <Box component="ol" sx={{ m: 0, pl: 2.5, mb: 1.5 }}>
//                           {guide.steps.map((step, si) => (
//                             <Box component="li" key={si} sx={{ fontSize: 13, mb: 0.5, color: "#424242" }}>
//                               {step}
//                             </Box>
//                           ))}
//                         </Box>
//                         <Box sx={{
//                           display: "flex", gap: 1, p: 1.2,
//                           backgroundColor: "#fffde7", borderRadius: 1.5,
//                           border: "1px solid #fff9c4"
//                         }}>
//                           <Typography fontSize={13} sx={{ color: "#f57f17" }}>💡</Typography>
//                           <Typography fontSize={12} color="#5d4037">{guide.tip}</Typography>
//                         </Box>
//                       </Box>
//                     )
//                   ))}

//                   <Box sx={{ mt: 2, p: 1.5, backgroundColor: "#f5f5f5", borderRadius: 1.5 }}>
//                     <Typography fontSize={12} fontWeight={600} mb={0.5} color="text.secondary">
//                       EXPECTED FILE FORMAT
//                     </Typography>
//                     <Box component="pre" sx={{
//                       m: 0, fontSize: 11, fontFamily: "monospace",
//                       color: "#424242", lineHeight: 1.8
//                     }}>
//                       {`from_url,to_url
// https://example.com/old-page,https://example.com/new-page
// /old-path,/new-path
// https://example.com/buy,https://example.com/buy-now`}
//                     </Box>
//                   </Box>
//                 </Box>
//               </Collapse>
//             </Box>
//           </>
//         ) : processing ? (
//           <Box sx={{ textAlign: "center", py: 7 }}>
//             <CircularProgress size={36} sx={{ mb: 2 }} />
//             <Typography fontSize={14} color="text.secondary">
//               {fileMeta?.parser === "pdf" ? "Extracting text from PDF…" : "Parsing file…"}
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             {/* ── File info bar ── */}
//             <Box sx={{
//               display: "flex", alignItems: "center", gap: 1.5, mb: 2, p: 1.5,
//               backgroundColor: "#f5f5f5", borderRadius: 1.5
//             }}>
//               <FileTypeIcon icon={fileMeta?.icon} />
//               <Box sx={{ flex: 1, minWidth: 0 }}>
//                 <Typography fontSize={14} fontWeight={500} noWrap>{file?.name}</Typography>
//                 <Typography fontSize={12} color="text.secondary">
//                   {fileMeta?.label} · {((file?.size || 0) / 1024).toFixed(1)} KB
//                 </Typography>
//               </Box>
//               <Chip icon={<CheckCircleIcon />} label={`${parsed.valid.length} valid`}
//                 color="success" variant="outlined" size="small" />
//               {parsed.invalid.length > 0 && (
//                 <Chip icon={<ErrorIcon />} label={`${parsed.invalid.length} skipped`}
//                   color="error" variant="outlined" size="small" />
//               )}
//             </Box>

//             {parsed.valid.length === 0 && (
//               <Alert severity="warning" sx={{ mb: 2, fontSize: 13 }}>
//                 No valid redirects found. Check that column A is "from URL" and column B is "to URL",
//                 both starting with <code>/</code> or <code>https://</code>.
//               </Alert>
//             )}

//             {parsed.valid.length > 0 && (
//               <Box sx={{ mb: 2 }}>
//                 <Typography fontSize={13} fontWeight={600} mb={1} color="text.secondary">
//                   WILL BE ADDED ({parsed.valid.length})
//                 </Typography>
//                 <Box sx={{
//                   maxHeight: 220, overflowY: "auto",
//                   border: "1px solid #e8f5e9", borderRadius: 1.5
//                 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow sx={{ backgroundColor: "#f1f8e9" }}>
//                         <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>From</TableCell>
//                         <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>To</TableCell>
//                         <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>Type</TableCell>
//                         <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>Active</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {parsed.valid.map((r, i) => (
//                         <TableRow key={i}>
//                           <TableCell sx={{
//                             fontFamily: "monospace", fontSize: 11, color: "#1565c0",
//                             maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"
//                           }}>
//                             {r.from_path}
//                           </TableCell>
//                           <TableCell sx={{
//                             fontFamily: "monospace", fontSize: 11, color: "#2e7d32",
//                             maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"
//                           }}>
//                             {r.to_url}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: 12 }}>{r.status_code ?? "—"}</TableCell>
//                           <TableCell sx={{ fontSize: 12 }}>{r.is_active ? "Yes" : "No"}</TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </Box>
//               </Box>
//             )}

//             {parsed.invalid.length > 0 && (
//               <Box>
//                 <Typography fontSize={13} fontWeight={600} mb={1} color="error.main">
//                   SKIPPED ({parsed.invalid.length})
//                 </Typography>
//                 <Box sx={{
//                   border: "1px solid #ffebee", borderRadius: 1.5,
//                   backgroundColor: "#fff8f8", p: 1.5, maxHeight: 120, overflowY: "auto"
//                 }}>
//                   {parsed.invalid.map((err, i) => (
//                     <Typography key={i} fontSize={12} mb={0.3}>
//                       <strong>Row {err.line}:</strong>{" "}
//                       <code style={{ color: "#c62828" }}>{err.raw}</code> — {err.reason}
//                     </Typography>
//                   ))}
//                 </Box>
//               </Box>
//             )}
//           </>
//         )}
//       </DialogContent>

//       <Divider />
//       <DialogActions sx={{ px: 2.5, py: 1.5, gap: 1 }}>
//         {parsed ? (
//           <>
//             <Button onClick={reset} variant="outlined"
//               sx={{ textTransform: "none", borderColor: "#bdbdbd", color: "#424242" }}>
//               Upload different file
//             </Button>
//             <Button onClick={handleConfirm} variant="contained"
//               disabled={loading || !parsed.valid.length}
//               sx={{
//                 textTransform: "none", backgroundColor: "#1976d2",
//                 "&:hover": { backgroundColor: "#1565c0" }, minWidth: 130
//               }}>
//               {loading
//                 ? <CircularProgress size={18} color="inherit" />
//                 : `Import ${parsed.valid.length} redirect${parsed.valid.length !== 1 ? "s" : ""}`}
//             </Button>
//           </>
//         ) : (
//           <Button onClick={handleClose} variant="outlined"
//             sx={{ textTransform: "none", borderColor: "#bdbdbd", color: "#424242" }}>
//             Cancel
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// }

import React, { useState, useRef } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Divider, CircularProgress,
  Chip, IconButton, Collapse, Tabs, Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const SUPPORTED = {
  "text/csv": { label: "CSV", icon: "table" },
  "text/tab-separated-values": { label: "TSV", icon: "table" },
  "text/plain": { label: "TXT", icon: "text" },
  "application/pdf": { label: "PDF", icon: "pdf" },
};

const ACCEPT = ".csv,.pdf";
const FORMAT_BADGES = ["CSV", "PDF"];

function getFileMeta(f) {
  if (SUPPORTED[f.type]) return SUPPORTED[f.type];
  const ext = f.name.split(".").pop().toLowerCase();
  return {
    csv: SUPPORTED["text/csv"],
    tsv: SUPPORTED["text/tab-separated-values"],
    txt: SUPPORTED["text/plain"],
    pdf: SUPPORTED["application/pdf"],
  }[ext] || null;
}

function FileTypeIcon({ icon }) {
  if (icon === "pdf") return <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />;
  if (icon === "table") return <TableChartIcon sx={{ color: "#2e7d32" }} />;
  return <InsertDriveFileIcon sx={{ color: "#1976d2" }} />;
}

const SAVE_GUIDES = [
  {
    label: "Google Sheets",
    steps: [
      "Open your sheet with redirect URLs",
      'Click File → Download → "Comma Separated Values (.csv)"',
      "Upload that CSV file here",
    ],
    tip: 'Make sure column A = "From URL" and column B = "To URL"',
  },
  {
    label: "Excel",
    steps: [
      "Open your Excel file",
      'Click File → Save As → choose "CSV UTF-8 (Comma delimited) (.csv)"',
      "Upload that CSV file here",
    ],
    tip: "Excel may warn about losing formatting — that's fine, click Keep.",
  },
  {
    label: "Notion / Confluence",
    steps: [
      "Select your redirect table",
      "Copy all cells (Ctrl+A then Ctrl+C)",
      'Use "Paste bulk" instead — paste directly into the text box',
    ],
    tip: "Notion tables paste as tab-separated, which works perfectly with Paste bulk.",
  },
  {
    label: "PDF / Word Doc",
    steps: [
      "Open the document and find the redirect table",
      "Select all rows and copy",
      'Use "Paste bulk" — paste the copied text there',
      "Or: save as .csv and upload here",
    ],
    tip: "PDFs with selectable text also work — just upload the .pdf file directly.",
  },
];

export default function UploadFileModal({ open, onClose, onSave, loading }) {
  const inputRef = useRef();
  const [file, setFile] = useState(null);
  const [fileMeta, setFileMeta] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [fileError, setFileError] = useState("");
  const [guideTab, setGuideTab] = useState(0);
  const [guideOpen, setGuideOpen] = useState(false);

  const reset = () => {
    setFile(null);
    setFileMeta(null);
    setFileError("");
  };

  const handleClose = () => { reset(); onClose(); };

  const processFile = (f) => {
    if (!f) return;
    const meta = getFileMeta(f);
    if (!meta) {
      setFileError(`Unsupported format. Accepted: ${FORMAT_BADGES.join(", ")}`);
      return;
    }
    setFile(f);
    setFileMeta(meta);
    setFileError("");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    processFile(e.dataTransfer.files[0]);
  };

  const handleConfirm = async () => {
    if (!file) return;
    await onSave(file);
    reset();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        pb: 1, fontWeight: 600, fontSize: "1rem"
      }}>
        Upload redirects file
        <IconButton size="small" onClick={handleClose}><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        {!file ? (
          <>
            {/* ── Format badges ── */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mb: 1.5 }}>
              {FORMAT_BADGES.map(f => (
                <Chip key={f} label={f} size="small" variant="outlined"
                  sx={{ fontSize: 11, height: 22, borderColor: "#e0e0e0", color: "#616161" }} />
              ))}
            </Box>

            {/* ── Drop zone ── */}
            <Box
              onClick={() => inputRef.current?.click()}
              onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={handleDrop}
              sx={{
                border: `2px dashed ${dragOver ? "#1976d2" : fileError ? "#d32f2f" : "#bdbdbd"}`,
                borderRadius: 2, p: 5, textAlign: "center", cursor: "pointer",
                backgroundColor: dragOver ? "#f0f7ff" : "#fafafa",
                transition: "all 0.2s",
                "&:hover": { borderColor: "#1976d2", backgroundColor: "#f0f7ff" },
              }}>
              <UploadFileIcon sx={{ fontSize: 44, color: dragOver ? "#1976d2" : "#bdbdbd", mb: 1 }} />
              <Typography fontWeight={500} mb={0.5}>Drag & drop your file here</Typography>
              <Typography fontSize={13} color="text.secondary">or click to browse</Typography>
              <Typography fontSize={12} color="text.secondary" mt={1}>
                CSV · PDF
              </Typography>
              {fileError && (
                <Typography fontSize={13} color="error" mt={1.5}
                  sx={{ maxWidth: 480, mx: "auto" }}>{fileError}</Typography>
              )}
            </Box>
            <input ref={inputRef} type="file" accept={ACCEPT} hidden
              onChange={(e) => processFile(e.target.files[0])} />

            {/* ── How to save guide ── */}
            <Box sx={{ mt: 2, border: "1px solid #e3f2fd", borderRadius: 2, overflow: "hidden" }}>
              <Box
                onClick={() => setGuideOpen(g => !g)}
                sx={{
                  display: "flex", alignItems: "center", gap: 1, px: 2, py: 1.2,
                  cursor: "pointer", backgroundColor: "#f0f7ff",
                  "&:hover": { backgroundColor: "#e3f2fd" },
                }}>
                <LightbulbOutlinedIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                <Typography fontSize={13} fontWeight={600} color="#1565c0" sx={{ flex: 1 }}>
                  How to export your redirect list as a file
                </Typography>
                {guideOpen
                  ? <ExpandLessIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                  : <ExpandMoreIcon sx={{ fontSize: 18, color: "#1976d2" }} />}
              </Box>

              <Collapse in={guideOpen}>
                <Box sx={{ px: 2, pt: 1.5, pb: 2 }}>
                  <Tabs value={guideTab} onChange={(_, v) => setGuideTab(v)}
                    sx={{
                      mb: 1.5, minHeight: 32,
                      "& .MuiTab-root": { textTransform: "none", fontSize: 12, minHeight: 32, py: 0.5 },
                      "& .Mui-selected": { color: "#1976d2 !important" },
                      "& .MuiTabs-indicator": { backgroundColor: "#1976d2" },
                    }}>
                    {SAVE_GUIDES.map((g, i) => <Tab key={i} label={g.label} />)}
                  </Tabs>

                  {SAVE_GUIDES.map((guide, i) => (
                    guideTab === i && (
                      <Box key={i}>
                        <Box component="ol" sx={{ m: 0, pl: 2.5, mb: 1.5 }}>
                          {guide.steps.map((step, si) => (
                            <Box component="li" key={si} sx={{ fontSize: 13, mb: 0.5, color: "#424242" }}>
                              {step}
                            </Box>
                          ))}
                        </Box>
                        <Box sx={{
                          display: "flex", gap: 1, p: 1.2,
                          backgroundColor: "#fffde7", borderRadius: 1.5,
                          border: "1px solid #fff9c4",
                        }}>
                          <Typography fontSize={13} sx={{ color: "#f57f17" }}>💡</Typography>
                          <Typography fontSize={12} color="#5d4037">{guide.tip}</Typography>
                        </Box>
                      </Box>
                    )
                  ))}

                  <Box sx={{ mt: 2, p: 1.5, backgroundColor: "#f5f5f5", borderRadius: 1.5 }}>
                    <Typography fontSize={12} fontWeight={600} mb={0.5} color="text.secondary">
                      EXPECTED FILE FORMAT
                    </Typography>
                    <Box component="pre" sx={{
                      m: 0, fontSize: 11, fontFamily: "monospace",
                      color: "#424242", lineHeight: 1.8,
                    }}>
                      {`from_url,to_url\nhttps://example.com/old-page,https://example.com/new-page\n/old-path,/new-path`}
                    </Box>
                  </Box>
                </Box>
              </Collapse>
            </Box>
          </>
        ) : (
          /* ── File selected — info bar only ── */
          <Box sx={{
            display: "flex", alignItems: "center", gap: 1.5, p: 1.5,
            backgroundColor: "#f5f5f5", borderRadius: 1.5, mt: 1,
          }}>
            <FileTypeIcon icon={fileMeta?.icon} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography fontSize={14} fontWeight={500} noWrap>{file.name}</Typography>
              <Typography fontSize={12} color="text.secondary">
                {fileMeta?.label} · {((file.size || 0) / 1024).toFixed(1)} KB
              </Typography>
            </Box>
            <Chip
              icon={<CheckCircleIcon />}
              label="Ready to upload"
              color="success"
              variant="outlined"
              size="small"
            />
          </Box>
        )}
      </DialogContent>

      <Divider />
      <DialogActions sx={{ px: 2.5, py: 1.5, gap: 1 }}>
        {file ? (
          <>
            <Button onClick={reset} variant="outlined"
              sx={{ textTransform: "none", borderColor: "#bdbdbd", color: "#424242" }}>
              Remove file
            </Button>
            <Button onClick={handleConfirm} variant="contained"
              disabled={loading}
              sx={{
                textTransform: "none", backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#1565c0" }, minWidth: 130,
              }}>
              {loading
                ? <CircularProgress size={18} color="inherit" />
                : `Upload ${fileMeta?.label || "file"}`}
            </Button>
          </>
        ) : (
          <Button onClick={handleClose} variant="outlined"
            sx={{ textTransform: "none", borderColor: "#bdbdbd", color: "#424242" }}>
            Cancel
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}